module.exports = __webpack_public_path__ + "static/media/user.fe37ec7e.svg";